import { jsx as _jsx } from "react/jsx-runtime";
import { Gear } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useState } from "react";
export const SettingsButton = /*#__PURE__*/ memo((param)=>{
    let { options, container, "data-testid": dataTestId } = param;
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        open: isOpen,
        onOpenChange: setIsOpen,
        container: container,
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            icon: Gear,
            label: "Settings",
            appearance: "ghost",
            color: "grey",
            "data-testid": dataTestId
        }),
        children: renderDropdownItems({
            options
        })
    });
});
SettingsButton.displayName = "SettingsButton";
